var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h2',[_vm._v("Links")]),_c('section',_vm._l((_vm.links),function(link){return _c('Link',{key:link.name,attrs:{"link":link}})}),1)])
}
var staticRenderFns = []

export { render, staticRenderFns }